import React from 'react';

import http from 'api/http';
import { componentAPI } from 'api/requests';

import Header from './Header';
import GeneralInformation from './GeneralInformation';
import FilePicker from 'Components/FilePicker';
import NotificationManager from 'dom-managers/notification';
import Modal from 'Components/Modal';
import Button, { buttonType, buttonColor } from 'Components/Button';
import ApplicationActions from 'Components/ApplicationActions';
import {Prompt} from 'react-router-dom';
import ComponentsFileCopyList from './ComponentsFileCopyList';
import Select from 'Components/Select';
import {Input} from 'Components/Input';
import FamilyInfo from './FamilyInfo';

export default class NewApplication extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      type: '',
      category: '',
      description: '',
      additionalFields: {},
      files: [],
      isModalOpen: false,
      requestInProcess: false,
      componentIdForTestReportsCopy: '',
      family: '',
      modalIsCopyTestReports: false,
      inputErrors: {},
      componentsWithTestReports:[],
    };

    this.someDataWasInputted = false;
    this.fileIdsToCopy = [];

    this.requiredFields = ['type', 'category', 'description'];
  }

  componentDidMount() {
    http.get(componentAPI.listWithReports).then(({ data: componentsWithTestReports }) => {
      this.setState({ componentsWithTestReports });
    });
  }

  handleSelectCategory = newCategory => {
    const {category} = this.state;
    let {inputErrors} = this.state;

    delete inputErrors.category;

    if (newCategory !== category) {
      if (newCategory) {
        this.setState({category:newCategory, type: null}, () => {
          if (newCategory.componentTypes.length === 1) {
            this.handleSelectType(newCategory.componentTypes[0])
          }
        })
      } else {
        this.setState({category:null, type: null, additionalFields:{}})
      }
    }
  };

  handleSelectType = newType => {
    const {type} = this.state;
    let {inputErrors} = this.state;

    delete inputErrors.type;

    if (newType !== type) {
      this.someDataWasInputted = true;
      this.setState(prevState => ({
        type:newType,
        description: !prevState.type || prevState.type.id !== newType.id ? '' : prevState.description,
        additionalFields: this.generateAdditionalFields(newType),
        files: [],
        family: '',
      }));
    }
  };

  handleSelectFamily = family => {
    this.setState({family:family})
  };

  generateAdditionalFields = type => {
    const fields = {};
    for (let field of type.componentTypeFields) {
      fields[field.id] = {
        required: field.required,
        value: ''
      };
    }
    return fields;
  };

  handleAdditionalFieldChange = id => event => {
    let {inputErrors} = this.state;
    const newValue = event.target ? event.target.value : event.value || event;

    this.someDataWasInputted = true;

    delete inputErrors[id];

    this.setState(prevState => ({
      additionalFields: {
        ...prevState.additionalFields,
        [id]: {
          ...prevState.additionalFields[id],
          value: newValue
        }
      },
      inputErrors
    }));
  };

  handleDescriptionChange = (value) => {
    let {inputErrors} = this.state;

    this.someDataWasInputted = true;

    if (value.length < 251) {
      delete inputErrors.description;
      this.setState({description: value, inputErrors});
    } else {
      inputErrors.description = 'Description must be 250 characters max';
      this.setState({inputErrors});
    }
  };

  handleFileSelect = files => {
    this.someDataWasInputted = true;
    this.setState(prevState => ({
      files: [...prevState.files, ...files]
    }));
  };

  handleRemoveFile = index => () => {
    this.someDataWasInputted = true;
    this.setState(prevState => {
      prevState.files.splice(index, 1);
      return {files: prevState.files};
    });
  };

  openFileCopyModal = () => {
    const {componentsWithTestReports} = this.state;

    if (componentsWithTestReports.length) {
      this.modalHeader = '';
      this.modalBody = this.getFileCopyModalBody(componentsWithTestReports);
      this.modalConfirmAction = this.copyFilesFromExistingReport;
      this.setState({modalIsCopyTestReports: true}, ()=> {
        this._openModal();
      });
    } else {
      NotificationManager.error('note', 'No components', 'There no existing components with test reports.');
    }
  };

  getFileCopyModalBody = componentsWithTestReports => () => {
    const {componentIdForTestReportsCopy} = this.state;

    return (
      <ComponentsFileCopyList
        selectReportIdForFileCopy={this.selectReportIdForFileCopy}
        selectedReportId={componentIdForTestReportsCopy}
        components={componentsWithTestReports}
      />
    );
  };

  selectReportIdForFileCopy = componentId => {
    this.setState({componentIdForTestReportsCopy: componentId})
  };

  copyFilesFromExistingReport = () => {
    const {componentIdForTestReportsCopy} = this.state;

    this.setState({requestInProcess:true}, () => {
      http.get(componentAPI.componentReportsInfo(componentIdForTestReportsCopy))
        .then(({data: componentReportsList}) => {
          this.someDataWasInputted = true;
          if (componentReportsList.length) {
            componentReportsList.forEach(report => {
              this.fileIdsToCopy.push(report.id)
            });
          }
          this.setState(prevState => ({
            files: [...prevState.files, ...componentReportsList]
          }));
        })
        .finally(() => {
          this._closeModal();
        })
    });
  };

  validateForm = () => {
    const {additionalFields, files, family} = this.state;
    let {inputErrors} = this.state;

    const isEmptyArray = object => {
      return object.length !== undefined && typeof object === 'object' && !object.length;
    };

    const isEmptyString = object => {
      return !object.length && typeof object === 'string' && !object.length;
    };

    const isEmptyObject = object => {
      return object.length === undefined && typeof object === 'object' && !Object.keys(object).length;
    };

    this.requiredFields.forEach(fieldName => {
      if (isEmptyString(this.state[fieldName]) || isEmptyArray(this.state[fieldName]) || isEmptyObject(this.state[fieldName])) inputErrors[fieldName] = true;
    });

    for (let key of Object.keys(additionalFields)) {
      if (additionalFields[key].required &&
        (isEmptyString(additionalFields[key].value) || isEmptyArray(additionalFields[key].value) || isEmptyObject(additionalFields[key].value))) {
        inputErrors[key] = true;
      }
    }

    return new Promise((resolve, reject) => {this.setState({inputErrors}, () => {
      if (Object.keys(this.state.inputErrors).length) {
        NotificationManager.error('note', 'Cannot submit the application.', 'Please check you information and try again.');
        reject();
      } else if (isEmptyArray(files) && !family) {
        NotificationManager.error('note', 'Cannot submit the application.', 'Select Family or upload at least one individual report file.');
        reject();
      } else {
        resolve();
      }
    });});
  };

  handleSubmitClick = () => {
    const {type, description, additionalFields, files, family} = this.state;
    const {user, updateComponentListEntry} = this.props;

    this.validateForm()
      .then(() => {
        const headers = {
          'Content-Type': 'multipart/form-data'
        };

        const requestJSON = {};
        requestJSON.description = description;
        requestJSON.componentTypeId = type.id;
        requestJSON.fieldValues = Object.keys(additionalFields).map(key => ({
          fieldId: key,
          value: additionalFields[key].value
        }));
        requestJSON.fileIdsToCopy = this.fileIdsToCopy;
        requestJSON.componentFamilyId = family ? family.id : null;

        const data = new FormData();
        data.append('requestJson', JSON.stringify(requestJSON));
        files.forEach(file => data.append('reports', file));

        this.modalHeader = 'Confirmation';
        this.modalBody = 'Are you sure you want to submit this application?';
        this.modalConfirmAction = () => {
          this.setState({requestInProcess: true}, () => {
            http.post(componentAPI.create, data, {headers})
              .then(({data}) => {
                NotificationManager.success('note', 'Your application was submitted successfully.');
                this.someDataWasInputted = false;
                this._closeModal();
                updateComponentListEntry({}, data);
                user.goToList();
              })
              .catch(() => {
                this._closeModal();
              })
          });
        };

        this._openModal();
      });
  };

  _openModal = () => {
    this.setState({isModalOpen: true});
  };

  _closeModal = (cb = () => {}) => {
    this.setState({isModalOpen: false, requestInProcess: false, modalIsCopyTestReports:false}, () => {if (typeof cb === 'function') cb();});
  };

  blockUnconfirmedTransition = location => {
    const {user} = this.props;

    if (this.someDataWasInputted) {
      this.modalHeader = 'Confirmation';
      this.modalBody = 'You have unsaved data. Are you sure you want to exit application without saving?';
      this.modalConfirmAction = () => {
        this.someDataWasInputted = false;
        this._closeModal(()=>{user.goTo(location)})
      };
      this._openModal();
      return false;
    }
    return true;
  };

  render() {
    const {isModalOpen, type, category, description, additionalFields, inputErrors, files,
      requestInProcess, family, componentIdForTestReportsCopy, modalIsCopyTestReports} = this.state;
    const {user, categories, families, familiesRequestInProcess} =this.props;

    const types = category ? category.componentTypes : [];

    return (
      <section className='scene__scene-wrapper'>
        <section className='scene__content-wrapper'>
          <Header user={user} />
          <section className='scene_section'>
            <header>Component</header>
            <Select
              selectionList={categories || []}
              type='primary'
              mainWrapperClassName='_margin_right_30'
              itemNameIndicator='name'
              label='Component Category * '
              isLoading={!categories.length}
              error={inputErrors.category}
              unclearable
              handleSelect={this.handleSelectCategory}
            />
            <Select
              selectionList={types}
              type='primary'
              itemNameIndicator='componentTypeName'
              label='Component Type *'
              isLoading={!categories.length}
              disabled={!types.length}
              error={inputErrors.type}
              defaultItem={type || {}}
              isSlave
              unclearable
              handleSelect={this.handleSelectType}
            />
          </section>
          {type && (
            <GeneralInformation
              handleAdditionalFieldChange={this.handleAdditionalFieldChange}
              type={type}
              types={category ? category.componentTypes : []}
              category={category}
              categories={categories}
              inputErrors={inputErrors}
              additionalFields={additionalFields}
            />
          )}
          {type && (
            <section className='scene_section'>
              <header>Description</header>
              <Input
                mainWrapperClassName='input__main-wrapper_primary _width_pc_100'
                inputClassName='input__input-field_primary'
                label='Component Description * (250 char. max)'
                value={description}
                onChange={this.handleDescriptionChange}
                error={inputErrors.description}
              />
            </section>
          )}
          {type && type.allowComponentFamily && (
            <FamilyInfo
              family={family}
              families={families}
              componentType={type}
              familiesRequestInProcess={familiesRequestInProcess}
              handleSelectFamily={this.handleSelectFamily}
            />
          )}
          {type && (
            <section className='scene_section'>
              <FilePicker
                editableStateSectionHeader={`Upload Component-specific Test Report${family ? '' : ' *'}`}
                sectionHeaderClassName='scene_section-header'
                infoMessage='Test reports in this section are component-specific and available for this component only'
                files={files}
                handleFileSelect={this.handleFileSelect}
                handleRemoveFile={this.handleRemoveFile}
              />
              <Button
                label='Copy from another component'
                type=''
                color=''
                buttonClassName='ect-file-picker__button _height_34 _width_145 _opacity_1'
                onClick={this.openFileCopyModal}
              />
            </section>
          )}
          <ApplicationActions
            cancelButtonLabel={'Cancel'}
            saveButtonLabel={'Submit'}
            saveButtonAction={this.handleSubmitClick}
            cancelButtonAction={user.goBack}
          />
        </section>

        <Modal isOpen={isModalOpen}>
          {this.modalHeader && <header className='ect-modal-header'>{this.modalHeader}</header>}
          <div className='ect-modal-body'>
            {typeof this.modalBody === 'function' ? this.modalBody() : this.modalBody}
          </div>
          <footer className='ect-modal-footer'>
            <Button
              label='No'
              type={buttonType.secondary}
              color={buttonColor.gray}
              buttonClassName='_height_40 _width_160'
              onClick={this._closeModal}
            />
            <Button
              label='Yes'
              disabledWithSpinner={requestInProcess}
              disabled={modalIsCopyTestReports && !componentIdForTestReportsCopy}
              buttonClassName='_height_40 _width_160'
              onClick={this.modalConfirmAction}
            />
          </footer>
        </Modal>
        <Prompt message={this.blockUnconfirmedTransition} />
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/Scenes/ComponentManufacturer/Application/New/index.jsx